import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroPencilSquare, heroTrash } from '@ng-icons/heroicons/outline';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AreaService } from 'src/app/api/services';
import { TableGenericComponent } from 'src/app/shared/component/table-generic/table-generic.component';
import {
  FormFieldConfig,
  TableAction,
  TableColumn,
} from 'src/app/shared/model/admin';
import { Area } from 'src/app/shared/model/area';
import { ModalFormComponent } from 'src/app/shared/component/modal-form/modal-form.component';
import { finalize, forkJoin } from 'rxjs';
import { ToastService } from 'src/app/shared/service/toast.service';
import { MESSAGES } from 'src/app/core/constant/messages';
import { LoadingComponent } from 'src/app/shared/component/loading/loading.component';
import { handleApiError } from 'src/app/shared/util/handle-api-error';

@Component({
  selector: 'app-area',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TableGenericComponent,
    ModalFormComponent,
    LoadingComponent,
  ],
  templateUrl: './area.component.html',
  viewProviders: [provideIcons({ heroPencilSquare, heroTrash })],
})
export class AreaComponent implements OnInit {
  mostrarModalAgregar: boolean = false;
  mostrarModalEditar: boolean = false;
  loadingAgregar: boolean = false;
  loadingEditar: boolean = false;
  loadingAreas: boolean = false;
  editarSeleccionada?: Area;

  areas: Area[] = [];

  formAgregar!: FormGroup;
  formEditar!: FormGroup;

  columns: TableColumn[] = [
    { header: 'Descripción', field: 'name' },
    { header: 'Estado', field: 'state' },
  ];
  actions: TableAction[] = ['edit'];

  fieldsAgregar: FormFieldConfig[] = [
    { name: 'name', label: 'Descripción', placeholder: 'Nombre del área' },
  ];
  fieldsEditar: FormFieldConfig[] = [
    { name: 'name', label: 'Descripción', placeholder: 'Nombre del área' },
    {
      name: 'state',
      label: 'Estado',
      type: 'select',
      options: [
        { label: 'Activo', value: 'activo' },
        { label: 'Inactivo', value: 'inactivo' },
      ],
    },
  ];

  constructor(
    private fb: FormBuilder,
    private areaService: AreaService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.initForms();
    this.cargarAreas();
  }

  private initForms(): void {
    this.formAgregar = this.fb.group({ name: ['', Validators.required] });
    this.formEditar = this.fb.group({
      name: ['', Validators.required],
      state: ['', Validators.required],
    });
  }

  private cargarAreas(): void {
    this.loadingAreas = true;
    this.areaService
      .areaGet()
      .pipe(
        handleApiError(this.toastService, MESSAGES.AREA.GET_ALL_ERROR),
        finalize(() => (this.loadingAreas = false))
      )
      .subscribe((res: any) => {
        this.areas = res.dto?.areas || [];
      });
  }
  openModal(type: 'add' | 'edit', area?: Area): void {
    this.mostrarModalAgregar = false;
    this.mostrarModalEditar = false;
    this.editarSeleccionada = undefined;

    if (type === 'add') {
      this.formAgregar.reset();
      this.mostrarModalAgregar = true;
      return;
    }

    if (type === 'edit' && area) {
      this.editarSeleccionada = area;
      this.formEditar.setValue({
        name: area.name,
        state: area.state,
      });
      this.mostrarModalEditar = true;
    }
  }

  crearArea(): void {
    if (this.formAgregar.invalid) {
      this.formAgregar.markAllAsTouched();
      return;
    }

    this.loadingAgregar = true;
    const { name } = this.formAgregar.value;

    this.areaService
      .areaPost({ body: { name } })
      .pipe(
        handleApiError(this.toastService, MESSAGES.AREA.CREATE_ERROR),
        finalize(() => (this.loadingAgregar = false))
      )
      .subscribe(() => {
        this.toastService.showMessages('success', [
          MESSAGES.AREA.CREATE_SUCCESS,
        ]);
        this.cargarAreas();
        this.mostrarModalAgregar = false;
      });
  }

  actualizarArea(): void {
    if (this.formEditar.invalid || !this.editarSeleccionada) {
      this.formEditar.markAllAsTouched();
      return;
    }

    this.loadingEditar = true;
    const { name, state } = this.formEditar.value;
    const idArea = this.editarSeleccionada.idArea;

    const nombre$ = this.areaService.areaIdAreaPatch({
      idArea,
      body: { name },
    });

    const estado$ = this.areaService.areaEstadoIdAreaPatch({
      idArea,
      body: { state },
    });

    forkJoin([nombre$, estado$])
      .pipe(
        handleApiError(this.toastService, MESSAGES.AREA.UPDATE_ERROR),
        finalize(() => (this.loadingEditar = false))
      )
      .subscribe(() => {
        this.toastService.showMessages('success', [
          MESSAGES.AREA.UPDATE_SUCCESS,
        ]);
        this.cargarAreas();
        this.mostrarModalEditar = false;
      });
  }
}
